import zxcvbn from 'zxcvbn';

export const MIN_PASSWORD_LENGTH = 8;
// Bound strength evaluation to the server's supported zxcvbn input length.
export const MAX_PASSWORD_LENGTH = 72;
export const MIN_PASSWORD_SCORE = 2;

export interface PasswordValidationResult {
  score: number;
  isLongEnough: boolean;
  isStrongEnough: boolean;
  message: string | null;
}

export const validatePasswordStrength = (password: string): PasswordValidationResult => {
  if (!password) {
    return {
      score: 0,
      isLongEnough: false,
      isStrongEnough: false,
      message: null,
    };
  }

  const passwordLength = Array.from(password).length;
  if (passwordLength > MAX_PASSWORD_LENGTH) {
    return {
      score: 0,
      isLongEnough: true,
      isStrongEnough: false,
      message: `Password must be at most ${MAX_PASSWORD_LENGTH} characters long.`,
    };
  }

  const analysis = zxcvbn(password);
  const score = analysis?.score ?? 0;
  const isLongEnough = passwordLength >= MIN_PASSWORD_LENGTH;
  const isStrongEnough = isLongEnough && score >= MIN_PASSWORD_SCORE;

  let message: string | null = null;
  if (!isLongEnough) {
    message = `Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`;
  } else if (!isStrongEnough) {
    message = 'Password is too common. Try a more unique passphrase.';
  }

  return {
    score,
    isLongEnough,
    isStrongEnough,
    message,
  };
};
